import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { ActivitiesFiltersParams } from '@recruitee/http-types';

import { ActivitiesDataScope, NotificationsStore } from '../../types';

@Injectable({ providedIn: 'root' })
export class NotificationsHttpService {
  constructor(protected httpApi: HttpApiService) {}

  public markAsViewed(unreadIds: number[]) {
    return this.httpApi.post('/tracking/notifications/mark_as_viewed', { unreadIds });
  }

  public markAsNotViewed(readIds: number[]) {
    return this.httpApi.post('/tracking/notifications/mark_as_not_viewed', { ids: readIds });
  }
  public markAllViewed() {
    return this.httpApi.patch('/tracking/notifications/mark_all_viewed');
  }
  public markAllNotViewed() {
    return this.httpApi.patch('/tracking/notifications/mark_all_not_viewed');
  }

  public markAllViewedByCandidate(candidateId: number) {
    return this.httpApi.patch(`tracking/candidates/${candidateId}/notifications/mark_all_viewed`);
  }

  public fetchTrackingNotifications(
    filters: ActivitiesFiltersParams,
    scope: string | undefined,
  ): Observable<NotificationsStore> {
    if (scope === ActivitiesDataScope.AllUnread || scope === ActivitiesDataScope.DropdownUnread) {
      return this.httpApi.get('/tracking/notifications/unread', { ...filters }).pipe(
        map(data => ({
          activities: data.activities,
        })),
      );
    }
    return this.httpApi.get('/tracking/notifications', { ...filters }).pipe(
      map(data => ({
        activities: data.activities,
      })),
    );
  }
}
